import { useState } from "react";
import ModelPage from "../../ModelPage";
import QrCode from "../../../../assets/img/qr__wooden.png";

const galleryData = {
    details: {
        items: [
            {
                image: "images/Wooden_Main.jpg",
                title: "Spruce Premium",
                subtitle: "PACKAGE",
                text: "Bring a touch of Zen into your home with a traditional wooden hot tub. Engineered with modern precision to designs that have lasted centuries, these tubs give any space a spa-like feel.",
            },
            {
                image: "images/Wooden_Internal_Heater_R1.jpg",
                title: "Internal heater",
                subtitle: "HEATER",
                text: "Built within the structure of the hot tub, internal stoves allow direct heat transfer with no danger to little hands and bare legs. Separated by a fence inside the tub, internal heaters are a subtle feature that let your Royal Tub’s natural features take centre stage.",
            },
            {
                image: "images/Royal-Tubs-0035.jpg",
                title: "Spruce Premium",
                subtitle: "PACKAGE",
                text: "A wood fired hot tub transports you to a world away from the stresses of everyday life, giving you a peaceful haven to retreat, relax and unwind. What will your escape look like?",
            },
            {
                image: "images/Royal-Tubs-0041.jpg",
                title: "Spruce Premium",
                subtitle: "PACKAGE",
                text: "Elegantly crafted to feel at home in any setting, a wood-fired hot tub adds a touch of warmth to your outdoor space. Whether you prefer sitting out on warm, Summer evenings or cosying beneath the water on a Snowy day, a hot tub is a treat you can enjoy year-round.",
            },
            {
                image: "images/Royal-Tubs-0043.jpg",
                title: "Spruce Premium",
                subtitle: "PACKAGE",
                text: "Whether nestled in the countryside or tucked away in a private garden, a wood-fired hot tub is the perfect venue to savour time with family, or reconnect with friends. Let your mind relax and your body unwind as you enjoy the simple pleasures of woodsmoke, warm water and good company.",
            },
        ],
    },
};

const keyFeaturesData = {
    text: "<h2>Key Features</h2><p>Sit back and gently unwind to the crackle of firewood and the soulful aroma of cut timber. Simple to operate and fast to heat, a Wooden Hot Tub is the purest way to take in the joys of nature, woodsmoke, and warm water.</p><p>The Premium package consists of 12 wood fired hot tub elements that will cover everything you need for a perfect hot tubbing needs:</p>",
    features: [
        {
            title: "1.8m Spruce Wooden hot tub",
            value: "(1799 value)",
        },
        {
            title: "Standard internal heater",
            value: "(£300 value)",
        },
        {
            title: "Stainless steel chimney with a heat guard",
            value: "(£125 value)",
        },
        {
            title: "Wooden cover around internal heater ",
            value: "(£125 value)",
        },
        {
            title: "Wood treatment",
            value: "(£55 value)",
        },
        {
            title: "Wooden lid",
            value: "(£160 value)",
        },
        {
            title: "Top rim decoration",
            value: "(£210 value)",
        },
        {
            title: "1 x mini bar / drink holder",
            value: "(£55 value)",
        },
        {
            title: "High-flow drain tap",
            value: "(£70 value)",
        },
        {
            title: "Stirring paddle",
            value: "(£55 value)",
        },
        {
            title: "LED underwater lighting (1 LED light)",
            value: "(£210 value)",
        },
        {
            title: "Submersible Skimatic Filter",
            value: "(£210 value)",
        },
    ],
    details: {
        items: [
            {
                image: "images/chimney-heat-guard-2.png",
                title: "Chimney Heat Guard",
                subtitle: "FLUE & DRAIN",
                text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
            },
            {
                image: "images/high-flow-drain-tap-deluxe.png",
                title: "High-Flow Drain Tap",
                subtitle: "FLUE & DRAIN",
                text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
            },
        ],
    },
};

const specs = {
    title: "Specifications",
    specs: [
        {
            title: "Capacity:",
            text: "Fits 6 adults",
        },
        {
            title: "Package weight:",
            text: "529,1 lbs (240 kg)",
        },
        {
            title: "Height:",
            text: "43 inches (1100 mm)",
        },
        {
            title: "External diameter:",
            text: "70,9 inch (1800 mm)",
        },
        {
            title: "Top rim diameter:",
            text: "+ 7,4 inch (190 mm)",
        },
        {
            title: "Chimney height:",
            text: "105 - 115 inches (2,6 – 3 m) from the ground up",
        },
        {
            title: "Water volume:",
            text: "475,5 gallons (1800 l)",
        },
        {
            title: "Heating time:",
            text: "Summer ± 3 hrs, Winter ± 4 hrs",
        },
        {
            title: "Heater fuel:",
            text: "Softwood/Hardwood",
        },
    ],
    details: {
        items: [
            {
                image: "images/chimney-heat-guard-2.png",
                title: "Chimney Heat Guard",
                subtitle: "FLUE & DRAIN",
                text: "Relax with complete peace of mind. Surrounding the flue, this cost-effective safety add-on prevents injury from accidental contact with the chimney.",
            },
            {
                image: "images/high-flow-drain-tap-deluxe.png",
                title: "High-Flow Drain Tap",
                subtitle: "FLUE & DRAIN",
                text: "Make maintenance easy – you’ll never have to get in a cold tub to drain down with a tapping outside. Also slashes the time to drain your tub, and allows connection to a draining hose (if you’d prefer to not flood the garden).",
            },
        ],
    },
};

const headlineData = {
    title: "Spruce Premium Package",
    discount: 6,
};

const breadcrumbData = [
    {
        title: "Wooden Hot Tub",
        active: true,
    },
    {
        title: "Packages",
        active: true,
    },
    {
        title: "Spruce Premium",
        active: false,
    },
];

const buttonLink = "https://sketchfab.com/models/2a4f2118c630400f807b933d3699ea11/embed-ar";

const customData = {
	Size: "1.8m",
	Heater: "Internal",
	"Heater Upgrades": "Cover around internal heater",
	Wood: "Spruce",
	Lid: "Wooden",
    "Electrical Add-ons": "LED Underwater Lighting",
    "Water Care Add-ons": "Submersible skimatic filter",
	"Flue / Drain Add-ons": "High-Flow Drain Tap, Chimney heat guard",
	"Wooden Add-ons": "Mini bar, Stirring paddle, Wooden steps, Top rim decoration, Wood treatment",
};

const Package1 = ({backToLabel}) => {
    const [color, setColor] = useState(0)
    const details = {
        base: {
            title: "Spruce Premium Package",
            price: 3450,
            configuredOptionsTotal: 2050,
            SRP: 3650,
            oldPrice: 3650,
        },
        heater: [
            {
                title: "Internal heater",
                price: 525,
            },
        ],
        InteriorAndExterior: [
            {
                title: "Wood treatment",
                price: 55,
            },
            {
                title: "Wooden lid",
                price: 0,
            },
        ],
    };
    
    return (
        <ModelPage
            wooId={1511}
            modelUID="2a4f2118c630400f807b933d3699ea11"
            qrCode={QrCode}
            videoUrl="https://www.youtube.com/embed/qu8BQjF3E8g"
            backToLabel={backToLabel}
            headlineData={headlineData}
            breadcrumbData={breadcrumbData}
            specs={specs}
            details={details}
            galleryData={galleryData}
            keyFeaturesData={keyFeaturesData}
            color={color}
            setColor={setColor}
            linerColor=""
            buttonLink={buttonLink}
            customData={customData}
        />
    );
}

export default Package1;
